export default "__VITE_PUBLIC_ASSET__c03dc014__"